import {useEffect, useState} from "react";
import {useSearchParams} from "react-router-dom";
import Switch from "react-switch";

import "./style.scss";

const SwitchFilter = ({data}) => {
    const {key, label} = data;
    const [searchParams, setSearchParams] = useSearchParams();
    const defaultChecked = searchParams.get(key);
    const [checked, setChecked] = useState(false);

    useEffect(() => {
        if (typeof defaultChecked !== "undefined") {
            setChecked(!!defaultChecked);
        }
    }, []);

    useEffect(() => {
        const valueHasChanged = !!defaultChecked !== checked;

        if (valueHasChanged) {
            const delayDebounceFn = setTimeout(() => {
                if (checked)
                    setValueToUrl("add");
                else
                    setValueToUrl("delete");
            }, 1000);

            return () => clearTimeout(delayDebounceFn);
        }
    }, [checked]);

    const setValueToUrl = (type) => {
        let updatedSearchParams = new URLSearchParams(searchParams.toString());

        if (type === "add")
            updatedSearchParams.set(key, checked && "1");

        if (type === "delete")
            updatedSearchParams.delete(key);

        setSearchParams(updatedSearchParams.toString());
    }

    const handleSwitchChange = (checked) => {
        setChecked(checked);

        let newParamsQuery = new URLSearchParams(searchParams);
        if (newParamsQuery.get("page")) {
            newParamsQuery.delete("page")
            setSearchParams(newParamsQuery);
        }
    };

    return (
        <section className="switch-filter">
            <h6 className="font-weight-bolder mb-0">
                {label}
            </h6>

            <Switch
                checked={checked}
                onChange={handleSwitchChange}
                className={checked ? "on" : "off"}
            />
        </section>
    );
}

export default SwitchFilter;
